import { Asterisk } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { currencyWords } from "@/config/site.config";

export const CurrencySection = () => (
  <section data-testid="currency-section" className="overflow-hidden border-y border-white/10 bg-coal">
    <div className="mx-auto max-w-4xl px-5 pb-10 pt-20 text-center sm:pt-28">
      <SectionHead eyebrow="WHAT CURRENCY ACTUALLY MEANS" center>
        CURRENCY IS
        <br />
        MORE THAN <span className="font-serif italic font-medium text-lime">CASH.</span>
      </SectionHead>
    </div>

    <div className="overflow-hidden border-y border-white/10 py-5">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex items-center">
            {currencyWords.map((w) => (
              <span key={`${dup}-${w}`} className="flex items-center">
                <span className="px-7 font-serif text-3xl italic text-cream/70 sm:text-5xl">{w}</span>
                <Asterisk className="h-5 w-5 text-lime" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>

    <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20">
      <Reveal className="space-y-2 text-xl font-extrabold leading-snug tracking-tight sm:text-3xl">
        <p>CLARITY CHANGES WHERE YOUR CURRENCY FLOWS.</p>
        <p>CAPACITY CHANGES HOW MUCH YOU CAN HOLD.</p>
        <p>YOUR DAILY RITUALS CHANGE WHO YOU BECOME.</p>
      </Reveal>
      <Reveal className="mt-10">
        <p className="font-mono text-[11px] tracking-[0.4em] text-lime">CLARITY IS CURRENCY™</p>
      </Reveal>
    </div>
  </section>
);
